<template>
  <v-dialog
    :value="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    :fullscreen="true"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular pl-5 pr-3"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-2"
          medium
          >mdi-satellite</v-icon
        >
        {{ $t("userNewPhotoGiftOrderSelectTypeTitle") }}
        <v-spacer></v-spacer>
        <v-btn
          text
          medium
          @click="active = false"
          style="min-width: 0; width: 20px"
        >
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid class="py-0">
          <v-layout row class="px-1 pt-2">
            <v-flex
              v-for="(item, index) in templateVar"
              :key="index"
              :id="item.id"
              xs12
              sm6
              md4
              lg3
              xl2
            >
              <v-card
                outlined
                class="mx-1"
                @click="selectedItem(item.id, item.inventory)"
              >
                <v-card-title
                  class="primary white--text justify-center subtitle-2 ma-0 py-1"
                  >{{ item.title }}</v-card-title
                >
                <v-card-text class="d-flex ma-0 pa-0">
                  <v-img
                    class="ma-2"
                    style="max-width: 100px; max-height: 100px"
                    :src="item.image"
                  ></v-img>
                  <div class="mx-1">
                    <div
                      class="subtitle-2 mt-2 font-weight-regular"
                      style="text-align: left"
                    >
                      {{ item.description }}
                    </div>
                    <div class="caption mt-1" style="text-align: left">
                      <span
                        v-if="item.inventory > 5"
                        class="pa-1"
                        style="
                          background-color: green;
                          color: white;
                          border-radius: 5px;
                        "
                      >
                        {{ $t("msgInventory") }}: {{ item.inventory }}
                        {{ $t("lmPcs") }}
                      </span>
                      <span
                        v-else-if="item.inventory > 1"
                        class="pa-1"
                        style="
                          background-color: #cc9900;
                          color: white;
                          border-radius: 5px;
                        "
                      >
                        {{ $t("msgInventoryLastPcs") }} ({{ item.inventory }})
                      </span>
                      <span
                        v-else-if="item.inventory == 1"
                        class="pa-1"
                        style="
                          background-color: #cc0000;
                          color: white;
                          border-radius: 5px;
                        "
                      >
                        {{ $t("msgInventoryLastPiece") }}
                      </span>
                      <span
                        v-else-if="item.inventory == 0"
                        class="pa-1"
                        style="
                          background-color: #cc0000;
                          color: white;
                          border-radius: 5px;
                        "
                      >
                        {{ $t("msgInventorySoldOut") }}
                      </span>
                      <span
                        v-else-if="item.inventory < 0"
                        class="pa-1"
                        style="
                          background-color: green;
                          color: white;
                          border-radius: 5px;
                        "
                      >
                        {{ $t("msgInventoryAvailable") }}
                      </span>
                    </div>
                    <div class="overline mb-2" style="text-align: left">
                      <v-icon>mdi-cash-multiple</v-icon>
                      {{ price(item.price) }}
                    </div>
                    <div v-if="item.discount" class="overline mb-2">
                      <span
                        class="pa-2"
                        style="
                          text-align: center;
                          background-color: #cc0000;
                          border-radius: 8px;
                          color: white;
                        "
                      >
                        {{ $t("userNewOrderSummary5aTitle") }}
                        {{ item.promoCode }}
                        <span v-if="item.discountType == 'Pct'"
                          >-{{ item.discount }}%</span
                        >
                        <span v-else-if="item.discountType == 'Amt'"
                          >-{{ price(item.discount) }}</span
                        ></span
                      >
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-template-selection",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    desc: {
      type: Boolean,
      required: true,
    },
    templateVar: {
      type: Array,
      required: true,
    },
  },
  computed: {
    active: {
      get() {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
    aDesc: {
      get() {
        return this.desc;
      },
      set: function (value) {
        this.$emit("update:desc", value);
      },
    },
  },
  methods: {
    selectedItem(id, inventory) {
      if (inventory != 0) {
        this.$emit("selectedId", id);
      }
    },
  },
};
</script>

<style scoped>
</style>